// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__29pQw","calendarButtons":"ClockData_calendarButtons__3u6lE"};